// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5bWxq","column":"styles_column__mDCVu","authenticationPage":"styles_authenticationPage__gWWR-"};